import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import { ocNumberMask } from "../../../../../utilities/masks";
import {
  selectIntroductoryPerpetratorData,
  selectUIData,
} from "../introductory.selectors";
import { setUIObjectField } from "../introductory.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INTRODUCTORY_PERPETRATOR,
  selector: selectIntroductoryPerpetratorData,
  redirect: Url.OC_VEHICLE_INCIDENT,
  content: [
    {
      title: "Dane sprawcy",
      sections: [
        {
          id: "introductory-perpetrator-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_REGISTRATION_NUMBER,
              label: "Numer rejestracyjny pojazdu sprawcy",
              required: true,
            },
            {
              type: FormElement.INPUT,
              prefix: "PL-OC",
              mask: ocNumberMask,
              id: ComponentId.PERPETRATOR_OC_NUMBER,
              label: "Numer polisy sprawcy",
              required: true,
            },
          ],
        },
        {
          id: "introductory-perpetrator-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_NAME,
              label: "Imię",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_SURNAME,
              label: "Nazwisko",
            },
          ],
        },
        {
          id: "introductory-perpetrator-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("perpetratorphone"),
              id: ComponentId.PERPETRATOR_PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_EMAIL,
              label: "Email",
            },
          ],
        },
      ],
    },
  ],
};
